import { push } from 'connected-react-router';
// jl-design-system
import getRegisteredFieldValues from 'jl-design-system/form/helpers/getRegisteredFieldValues';
// lodash
import get from 'lodash/get';
import { destroyForm } from 'jl-design-system/redux/actions/form/formActions';
import { showBatchingFailureModal } from '../edit-basket/editBasketActions';
import { resetApp } from '../reset/resetActions';
import routeConstants from '../../../constants/routeConstants';
import { removeStorageItem } from '../../../utils/storage/storage';
import validateEmail from '../../../utils/email-validation/emailValidatorProxy';
import {
  GET_LOGIN_PAGE,
  LOGIN_CREDS,
  LOGIN_RESET,
  SHOW_EMAIL_VALIDATION_ERROR,
} from '../../../constants/actionConstants';
import errorCodeConstants from '../../../constants/errorCodeConstants';
import {
  URL_LOGIN_PAGE_AUTH0_FALLBACK,
  URL_LOGIN_SESSIONS_V2,
  URL_LOGIN_SESSIONS_V2_WITH_LOGIN_TYPE,
} from '../../../constants/endpointConstants';
import { GUEST_FORM_ID } from '../../../utils/form/configs/login';
import {
  initLogging,
} from '../../../utils/logging/logging-utils';
import { getFeatures } from '../bff/bffActions';
import loginTypeConstants from '../../../constants/loginTypeConstants';
import { isApps, isPactApp } from '../../reducers/app/appReducer';

export const getFallbackLoginPage = auth0Fallback => async (dispatch, getState) => {
  if (get(getState().app, 'orderComplete', false)) {
    return {};
  }

  return dispatch({
    type: GET_LOGIN_PAGE,
    request: client => client({
      path: URL_LOGIN_PAGE_AUTH0_FALLBACK(auth0Fallback),
      config: { method: 'GET' },
    }),
  });
};

export const loginCredentials = (loginParams = {}, getState) => {
  let loginType = get(getState(), 'login.loginType');
  if (loginType === undefined) {
    if (isApps(getState())) {
      loginType = loginTypeConstants.CUSTOMER_APPS;
    }
    if (isPactApp(getState())) {
      loginType = loginTypeConstants.PACT_APPS;
    }
  }
  const loginUrl = loginType === undefined ? URL_LOGIN_SESSIONS_V2 : URL_LOGIN_SESSIONS_V2_WITH_LOGIN_TYPE(loginType);
  return {
    type: LOGIN_CREDS,
    request: client => client({ path: loginUrl, config: { method: 'PUT', body: loginParams } }),
  };
};

export const submitAndHandleLogin = loginParams => async (dispatch, getState) => {
  if (!await validateEmail(loginParams.email)) {
    dispatch({
      type: SHOW_EMAIL_VALIDATION_ERROR,
    });
  } else {
    const response = await dispatch(loginCredentials(loginParams, getState));

    if (response.type === `${LOGIN_CREDS}.SUCCESS`) {

      removeStorageItem('email');
      dispatch(resetApp(LOGIN_RESET, loginTypeConstants.LEGACY));
      dispatch(destroyForm(GUEST_FORM_ID));

      await dispatch(getFeatures());
      dispatch(initLogging());
      dispatch(push({ pathname: routeConstants.DELIVERY_CHOICE }));
    }

    if (response.type === `${LOGIN_CREDS}.FAILED` && response.error.code === errorCodeConstants.BATCHING_FAILURE) {
      // TODO is this ever possible now?
      const batchingFailureIds = get(response, 'error.inconsistentBatchProducts', []);
      await dispatch(showBatchingFailureModal(batchingFailureIds, loginTypeConstants.LEGACY));
    }
  }
};

export const onRemoveBatchingFailureLegacyLoginHandler = () => async (dispatch, getState) => {
  const loginForm = get(getState(), 'form.guestForm');

  const { registeredFields, values } = loginForm;
  const registeredFieldValues = getRegisteredFieldValues(values, registeredFields);
  const body = { ...registeredFieldValues };

  dispatch(submitAndHandleLogin(body));
};
